<template>
    <div id="identification-information" class="tab-pane fade">
        <div class="row">
            <div class="col-md-3">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Document Type</label>
                <p class="mg-b-0">{{ company.identification_document_type|placeholder }}</p>
            </div>
            <div class="col-md-3">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Document No</label>
                <p class="mg-b-0">{{ company.identification_document_number|placeholder }}</p>
            </div>
            <div class="col-md-3">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Country of Issue</label>
                <p class="mg-b-0">{{ company.identification_document_country|placeholder }}</p>
            </div>
            <div class="col-md-3">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Expiry Date</label>
                <p class="mg-b-0">{{ company.identification_document_expiry_date|placeholder }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Country of Domicile</label>
                <p class="mg-b-0">{{ company.country_of_domicile|placeholder }}</p>
            </div>
            <div class="col-md-3 mg-t-10 mg-sm-t-20">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Country for Tax</label>
                <p class="mg-b-0">{{ company.country_for_tax|placeholder }}</p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        data() {
			const {
				identification_document_type,
				identification_document_number,
				identification_document_expiry_date,
				identification_document_country,
				tin,
				csd_id,
				nationality,
				country_for_tax,
			} = this.company;

			return {
				identification: {
					identification_document_type,
					identification_document_number,
					identification_document_expiry_date,
					identification_document_country: identification_document_country || "Ghana",
					tin,
					csd_id,
					nationality,
					country_for_tax,
				},
			};
		},
		props: ["company"]
	};
</script>